import { render, staticRenderFns } from "./wsPdf.vue?vue&type=template&id=2776281d&scoped=true&"
import script from "./wsPdf.vue?vue&type=script&lang=js&"
export * from "./wsPdf.vue?vue&type=script&lang=js&"
import style0 from "./wsPdf.vue?vue&type=style&index=0&id=2776281d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2776281d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
